import Cookies from "js-cookie";
import * as Sentry from "../../config/sentry";

class BotClient1 {
  constructor() {
    this.config = {
      headers: { Authorization: `Bearer ${this.directLineSecret}` },
    };
  }

  async handleUserBot({
    userInput,
    isConversationInitiated,
    candidateResponseId,
    botResponseId,
    currentRequestId,
    interruptionData,
  }) {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/interact_with_bot`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
          body: JSON.stringify({
            response: userInput,
            is_initiator: !isConversationInitiated,
            candidate_response_id: candidateResponseId,
            bot_response_id: botResponseId,
            request_id: currentRequestId,
            interruption_data: interruptionData,
          }),
        }
      );

      let bot_response = await response.json();
      return bot_response;
    } catch (error) {
      console.error("Error occurred during interaction:", error);
      throw error;
    }
  }

  async candidateStartRecognition() {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/interact_with_bot/start`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      let bot_response = await response.json();
      return bot_response;
    } catch (error) {
      console.error("Error occurred during login:", error);
    }
  }

  async botResponseInterrupted(
    candidateResponseId,
    botResponseId,
    currentConversationState,
    currentConversationTemplate,
    currentQuestion,
    nextQuestion,
    elaborationRequests,
    currentRequestId
  ) {
    try {
      const jwt = Cookies.get("jwt");
      console.log(`Bot Interrupted #${currentRequestId} - ${new Date()}`);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/interact_with_bot/interrupted`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
          body: JSON.stringify({
            candidate_response_id: candidateResponseId,
            bot_response_id: botResponseId,
            state: currentConversationState,
            template: currentConversationTemplate,
            current_question: currentQuestion,
            next_question: nextQuestion,
            elaborations_requested: elaborationRequests,
          }),
        }
      );
      let bot_response = await response.json();
      return bot_response;
    } catch (error) {
      console.error("Error occurred during login:", error);
    }
  }

  async getSasUrl() {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/upload_sas_url`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      let bot_response = await response.json();
      return bot_response;
    } catch (error) {
      console.error("getSasUrl Failed - ", error);
      Sentry.captureException(error);
      throw error;
    }
  }

  async getDeepgramToken() {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL || 'http://localhost:8000'}/get_deepgram_token`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const tokenData = await response.json();
      return tokenData?.deepgram_token;
    } catch (error) {
      console.error("getDeepgramToken Failed - ", error);
      Sentry.captureException(error);
      throw error;
    }
  }

  async getHeyGenAccessToken() {
    try {
      const jwt = Cookies.get("jwt");
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/get_heygen_token`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      const data = await res.json();
      return data?.heygen_token;
    } catch (error) {
      throw error;
    }
  }

  // LiveAvatar API Methods
  async getLiveAvatarApiToken() {
    try {
      const jwt = Cookies.get("jwt");
      console.log("jwt : ",jwt)
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/get_liveavatar_token`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("getLiveAvatarApiToken Failed - ", error);
      Sentry.captureException(error);
      throw error;
    }
  }

  // Delete Context API
  async deleteLiveAvatarContext(meetingId) {
    try {
      const jwt = Cookies.get("jwt");
      console.log("jwt : ",jwt)
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/contexts/delete`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
          body: JSON.stringify({
            meeting_id: meetingId,
          }),
        }
      );
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("deleteLiveAvatarContext Failed - ", error);
      Sentry.captureException(error);
      throw error;
    }
  }

}

export default BotClient1;
